import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import {
  IconFilter,
  FilterSelectComponent,
} from 'nallian-shared-ui/lib/components/semantic-filter-components';
import lookupService from 'nallian-shared-ui/lib/hoc/lookupService';
import { addParametersToUri } from 'nallian-shared-ui/lib/lib/uri';
import apiRoutes from '../../../../../app/api/routes';

const CommunityMemberRolesFilter = ({ filterCommunityMemberRolesFetch }) => {
  const roleOptions = useMemo(
    () =>
      (filterCommunityMemberRolesFetch.value?.communityRoles || []).map(r => ({
        key: r.tag,
        value: r.tag,
        text: r.name,
      })),
    [filterCommunityMemberRolesFetch.value]
  );

  return (
    <IconFilter
      hasApplyButton
      name="organisationRoleTag"
      position="bottom right"
      placement="bottom-end"
      as={FilterSelectComponent}
      options={roleOptions}
    />
  );
};

CommunityMemberRolesFilter.propTypes = {
  filterCommunityMemberRolesFetch: PropTypes.object.isRequired,
};

export default compose(
  lookupService(({ communityId }) => ({
    resource: 'filterCommunityMemberRoles',
    url: addParametersToUri(apiRoutes.communityRoles2(communityId), { page: 1, pageSize: 100 }),
  }))
)(CommunityMemberRolesFilter);
